// The stack a pull request page last found, held for the app (above the
// pages, which are rebuilt per pull request): going from one member of a
// stack to the next shows the stack at once, from here, and asks GitHub
// nothing. One stack is held, the last one read; another account signing
// in drops it.
import { onIdentityChange } from '../api/identity';
import type { StackRowPr } from '../api/queries';
import type { StackPool } from '../logic/prStack';

/** A stack's members as a page read them, and when (epoch ms). */
export interface HeldStack {
  /** The repository of the page that read them. */
  repo: string;
  prs: StackRowPr[];
  hidden: string[];
  cut: boolean;
  source: StackPool['source'];
  since: number;
}

let held: HeldStack | null = null;

export const stackHold = {
  /** Hold `pool`, read at `since` for a pull request of `repo`. */
  put(repo: string, pool: StackPool, since: number) {
    held = { repo, prs: pool.prs, hidden: pool.hidden, cut: pool.cut, source: pool.source, since };
  },
  get(): HeldStack | null {
    return held;
  },
  clear() {
    held = null;
  },
};

onIdentityChange(() => stackHold.clear());
